(function(angular){
	'use strict';
	
	angular
		.module('loginCaptchaModule', [
			'coreModule',
			'formValidationModule',
			'googleRecaptchaModule',
			'vcRecaptcha'
		]);

})(window.angular);